module.exports = __webpack_public_path__ + "static/media/details-1-image-5.19fb7458.png";